import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, OccConfig } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { CountrySelectorService } from 'src/app/customServices/country-selector.service';

@Component({
  selector: 'app-kb-country-flag',
  templateUrl: './kb-country-flag.component.html',
  styleUrls: ['./kb-country-flag.component.scss'],
  standalone: false
})
export class KbCountryFlagComponent {
  public baseUrl = this.config?.backend?.occ?.baseUrl + '/';
  isLoggedIn = false;
  subscription = new Subscription();
  constructor(
    public countrySelectorService: CountrySelectorService,
    private authService: AuthService,
    private router: Router,
    private config: OccConfig
  ) { }

  getCountrySelectorPageRoute(event: Event) {
    event.preventDefault();
    this.router.navigate(['/countrySelectorPage']);
  }

  ngOnInit() {
    this.subscription.add(this.authService
      .isUserLoggedIn()
      .pipe(distinctUntilChanged())
      .subscribe((data: boolean) => {
        this.isLoggedIn = data;
      }));
  }


  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
